import React, { useState } from "react";
import { Menu, Dropdown, Avatar, Typography } from "antd";
import { connect, useDispatch } from "react-redux";
import {
    SettingOutlined,
    LogoutOutlined,
    EditOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "redux/actions/Auth";
import { useHistory } from "react-router-dom";
import Utils, { setLocale } from "utils";
import ChangePasswordModal from "../shared-components/ChangePasswordModal";

export const NavProfile = (props) => {
    const { Title } = Typography;
    const { signOut, username, code, role, avatar } = props;
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const dispatch = useDispatch();


    let history = useHistory();
    let profileImg = "/img/avatars/thumb-1.png";

    const profileMenu = (
        <div className="nav-profile nav-dropdown">
            <div className="nav-profile-header">
                <div className="d-flex">
                    <Avatar size={50} src={avatar ? Utils.getImageFormString(avatar) : profileImg} />
                    <div className="pl-3">
                        <h4 className="mb-0">{username}</h4>
                        <p className="mb-0">{code}</p>
                    </div>
                </div>
            </div>
            <div className="nav-profile-body">
                <Menu>
                    <Menu.Item
                        key={4}
                        onClick={() => history.push("/app/profile")}
                    >
                        <Icon className="mr-3" type={EditOutlined} />
                        <span className="font-weight-normal">{setLocale(true, "profile.edit")}</span>
                    </Menu.Item>
                    <Menu.Item
                        key={5}
                        onClick={() => setShowPasswordModal(true)}
                    >
                        <Icon className="mr-3" type={SettingOutlined} />
                        <span className="font-weight-normal">{setLocale(true, "profile.password_change")}</span>
                    </Menu.Item>
                    <Menu.Item
                        key={6}
                        onClick={(e) => {
                            dispatch(signOut());
                            history.push("/auth/login");
                        }}
                    >
                        <span>
                            <LogoutOutlined className="mr-3" />
                            <span className="font-weight-normal">{setLocale(true, "profile.signout")}</span>
                        </span>
                    </Menu.Item>
                </Menu>
                <ChangePasswordModal visible={showPasswordModal} setShowModal={setShowPasswordModal} />
            </div>
        </div>
    );

    return (
        <>
            <Dropdown
                placement="bottomRight"
                overlay={profileMenu}
                trigger={["click"]}
            >
                <Menu className="d-flex align-item-center" mode="horizontal">
                    <Menu.Item key="profile">
                        <Avatar src={avatar ? Utils.getImageFormString(avatar) : profileImg} />
                    </Menu.Item>
                </Menu>
            </Dropdown>
        </>
    );
};

const mapStateToProps = ({ auth }) => {
    const { username, role, code, avatar } = auth;
    return { username, role, code, avatar };
};

export default connect(mapStateToProps, { signOut })(NavProfile);
